import { render, staticRenderFns } from "./circle-loading.vue?vue&type=template&id=2884b5c9"
import script from "./circle-loading.vue?vue&type=script&lang=js"
export * from "./circle-loading.vue?vue&type=script&lang=js"
import style0 from "./circle-loading.vue?vue&type=style&index=0&id=2884b5c9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports